import { render, staticRenderFns } from "./UserOverview.vue?vue&type=template&id=7ab49fd4&scoped=true&"
import script from "./UserOverview.vue?vue&type=script&lang=ts&"
export * from "./UserOverview.vue?vue&type=script&lang=ts&"
import style0 from "./UserOverview.vue?vue&type=style&index=0&id=7ab49fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab49fd4",
  null
  
)

export default component.exports